import React from 'react';
import { FilterForm, useFilterFormActions } from './filter-form';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';

export const BooleanFilters = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems} />
);

function BooleanFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  if (column.id == 'multiparty_deal') {
    return (
      <>
        <FormControlLabel
          value="False"
          control={<Radio />}
          label="Single Party deal"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="True"
          control={<Radio />}
          label="Multi Party deal"
          name="$eq"
          inputRef={form.register}
        />
      </>
    );
  } else if (column.id == 'multicontent_deal') {
    return (
      <>
        <FormControlLabel
          value="False"
          control={<Radio />}
          label="Atmost One Content deal"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="True"
          control={<Radio />}
          label="Multi Content deal"
          name="$eq"
          inputRef={form.register}
        />
      </>
    );
  }
  else if (column.id == 'deal_status') {
    return (
      <>
        <FormControlLabel
          value="Active"
          control={<Radio />}
          label="Active"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Cancelled"
          control={<Radio />}
          label="Cancelled"
          name="$eq"
          inputRef={form.register}
        />
        <FormControlLabel
          value="Expired"
          control={<Radio />}
          label="Expired"
          name="$eq"
          inputRef={form.register}
        />
      </>
    );
  }
  else {
    return (
      <>
        <FormControlLabel
          value="false"
          control={<Radio />}
          label="Contains a Deal Badge"
          name="$empty"
          inputRef={form.register}
        />
        <FormControlLabel
          value="true"
          control={<Radio />}
          label="Empty Deal Badge"
          name="$empty"
          inputRef={form.register}
        />
      </>
    );
  }
}
